import { useEffect, useRef, useState } from "preact/hooks";
// import { useContext, useState, useEffect, useRef } from "preact/hooks";
// import { DatabaseProvider } from "../db/db-setup.js";
// import { RxTodoDocument } from "../db/items.js";
import { Chat } from "./Chat.js";
import { localConfigStorage } from "../util/local-config.js";
import { usePromise } from "../util/usePromise.js";
import { randomToken } from "rxdb";

declare global {
    interface QRCode {
        new (el: HTMLElement, options:any): QRCode;
        clear(): void;
    }
    interface Window {
        QRCode: QRCode;
    }
}

export function Layout({}) {
    const qrContainer = useRef<HTMLDivElement>(null);
    // const db = useContext(DatabaseProvider);

    // const [items, setItems] = useState([] as RxTodoDocument[]);
    // useEffect(() => {
    //     if (db) {
    //         db.items.find().exec().then(x => setItems(x));
    //         db.items.find().$.subscribe(x => setItems(x));
    //     }
    // }, [db]);

    useEffect(() => {
        let qrCanvas: QRCode
        if (qrContainer.current) {
            qrCanvas = new window.QRCode(qrContainer.current, {
                text: window.location.href,
                useSVG: false,
            });
            return () => qrCanvas.clear();
        }
    }, [])

    const [recentChats, setRecentChats] = useState<any | null>(null);
    useEffect(() => {
        if (!recentChats) {
            localConfigStorage.getValue("recentRooms").then(x => {
                setRecentChats(x);
            });
        }
    }, [recentChats]);
    const [editChat, setEditChat] = useState<string | null>(null);

    return (
        <div className="container">
            <Chat />
            <div ref={qrContainer} style={{padding: "2em", "background-color": "white"}}></div>
            { recentChats && <div style={{padding: "2em", "background-color": "white"}}>
                <h2>Recent Chats</h2>
                <ul>
                    {Object.keys(recentChats).map(x => <li key={x} className="mb-2">
                        {editChat === x ?
                            <input type="text" value={recentChats[x].name || ""} onInput={e => {
                                const z = { ...recentChats, [x]: { ...(recentChats[x] || {}),name: (e.target as HTMLInputElement).value } };
                                localConfigStorage.storeValue("recentRooms", z);
                                setRecentChats(z);
                            }} />
                            :
                            <a href={x} onClick={e => {
                                window.location.hash = x;
                                window.location.reload();
                            }}>{(recentChats[x].name && recentChats[x].name.length > 0) ? recentChats[x].name : x}</a>
                        }
                        {" "}
                        <button className="btn btn-primary btn-sm" onClick={e => {
                            x !== editChat ? setEditChat(x) : setEditChat(null);
                        }}><i className="fa-solid fa-pen"></i></button>
                        {" "}
                        <button className="btn btn-danger btn-sm" onClick={e => {
                            if (confirm("Are you sure?")) {
                                const z = { ...recentChats, [x]: undefined };
                                localConfigStorage.storeValue("recentRooms", z);
                                setRecentChats(z);
                            }
                        }}><i className="fa-solid fa-trash"></i></button>
                    </li>)}
                </ul>
                <button className="btn btn-primary" onClick={e => {
                    const newValue = {...recentChats, [`#room-${randomToken(10)}`]: {}};
                    localConfigStorage.storeValue("recentRooms", newValue);
                    setRecentChats(newValue);
                }}>New Chat</button>
            </div>}
        </div>
    );

    // <ul>
    //     {items.map((item: RxTodoDocument) => <li key={item.id}>
    //         {item.title} - {item.id}
    //         <button onClick={e => item.remove()}>Delete</button>
    //     </li>)}
    // </ul>
    // {db && <button onClick={e => db.items.insert({ title: "Hello, Solid!", lastChange: Date.now(), id: new Date().getTime().toString() })}>Add</button>}
}